import { httpV1 as http } from '@/services/api';

export async function getRewardReport(params) {
  return http
    .get('/antecipate-fgts/reward-report', { params })
    .then(({ data }) => data);
}

export async function getResponsibleReport(params) {
  return http
    .get('/users/responsibles-report', { params })
    .then(({ data }) => data);
}

export async function getPaymentFlow(params) {
  return http
    .get('/antecipate-fgts/payment-flow', { params })
    .then(({ data }) => data);
}

export async function getCommission(params) {
  return http
    .get('/antecipate-fgts/comissions', { params })
    .then(({ data }) => data);
}
